export interface PortfolioProject {
  id: number;
  title: string;
  category: string;
  tech: string[];
  description: string;
  results: string;
  url?: string; // Optional client site URL
  image: string; // Screenshot/preview image path
  color: string;
  position: [number, number, number]; // Legacy 3D position (keeping for compatibility)
  // Solar system properties
  orbitRadius: number; // Distance from sun
  orbitSpeed: number; // Orbital speed
  planetSize: number; // Planet size
  startAngle: number; // Starting position in orbit (radians)
  planetType: 'rocky' | 'gas' | 'ice' | 'lava'; // Visual style
}

export const portfolioProjects: PortfolioProject[] = [
  {
    id: 1,
    title: 'Watershed HR',
    category: 'React/Next.js',
    tech: ['Next.js', 'React', 'TypeScript', 'AI Integration', 'Real-time Chat'],
    description: 'A digital marketplace platform connecting Super Funds with verified Financial Advisers to help members with retirement planning. Purpose-built for Australia\'s Retirement Income Covenant (RIC) compliance requirements.',
    results: '200+ Super Funds connected, 15,000+ active advisers, 100,000+ members served with 99.9% compliance accuracy',
    url: 'https://watershedhr.netlify.app/',
    image: '/portfolio/watershedhr.png',
    color: '#3b82f6', // blue
    position: [0, 0, 0],
    orbitRadius: 5,
    orbitSpeed: 0.003,
    planetSize: 0.6,
    startAngle: 0, // 0 degrees
    planetType: 'rocky',
  },
  {
    id: 2,
    title: 'Two Souls Co',
    category: 'WordPress/WooCommerce',
    tech: ['WordPress', 'WooCommerce', 'Custom Theme', 'Calendly Integration'],
    description: 'A compassionate e-commerce platform offering the Soul Collection Kit - an Australian-first solution for women experiencing early pregnancy loss. Provides dignified resources for bereaved families and healthcare professionals.',
    results: 'Endorsed by major healthcare organizations including The Pink Elephants Support Network and Mater Mothers Hospital. Serving bereaved families Australia-wide with clinically validated, ethically designed products.',
    url: 'https://twosoulsco.netlify.app/',
    image: '/portfolio/twosoulsco.png',
    color: '#a855f7', // purple
    position: [4, 1, -2],
    orbitRadius: 7,
    orbitSpeed: 0.0025,
    planetSize: 0.7,
    startAngle: Math.PI / 3, // 60 degrees
    planetType: 'gas',
  },
  {
    id: 3,
    title: 'Countable',
    category: 'React/Next.js',
    tech: ['Next.js', 'React', 'TypeScript', 'Tailwind CSS', 'Netlify'],
    description: 'A comprehensive accounting and business advisory platform serving small businesses across Australia. Led by a CPA with nearly 15 years of experience, providing streamlined financial solutions with proven systems and processes.',
    results: 'Servicing clients Australia-wide across 9+ industries including Health & Fitness, Technology, Retail, and eCommerce. ASIC compliant and BAS registered practice.',
    url: 'https://www.countable.com.au/',
    image: '/portfolio/countable.png',
    color: '#f97316', // orange
    position: [-4, -1, -2],
    orbitRadius: 9,
    orbitSpeed: 0.002,
    planetSize: 0.5,
    startAngle: Math.PI, // 180 degrees
    planetType: 'lava',
  },
  {
    id: 4,
    title: 'Wright Compliance',
    category: 'WordPress',
    tech: ['WordPress', 'WooCommerce', 'Custom Theme', 'eStore Integration'],
    description: 'A comprehensive compliance solutions platform for Australian Financial Services (AFS) Licensees. Simplifies regulatory compliance through personalized service, ASIC submission preparation, and ongoing compliance management support.',
    results: 'Trusted compliance partner for AFS Licensees across Australia. Offering full-service support from initial licensing to ongoing compliance management with comprehensive policy libraries and consulting services.',
    url: 'https://wrightcompliance.com.au/',
    image: '/portfolio/writecompliance.png',
    color: '#06b6d4', // cyan
    position: [3, -1.5, 2],
    orbitRadius: 11,
    orbitSpeed: 0.0018,
    planetSize: 0.55,
    startAngle: Math.PI * 1.5, // 270 degrees
    planetType: 'ice',
  },
  {
    id: 5,
    title: 'Maryborough Whistle Stop',
    category: 'React/Next.js',
    tech: ['Next.js', 'React', 'TypeScript', 'Netlify', 'Heritage Branding'],
    description: 'A heritage railway preservation website showcasing Maryborough\'s rich railway history. Features the iconic Mary Ann steam train, railway museum, and Locomotive #299 restoration. Run by passionate volunteers dedicated to preserving Queensland\'s railway heritage since 1999.',
    results: 'Serving tourists and heritage enthusiasts with multiple major sponsors including Fraser Coast Regional Council and Queensland Rail. Active volunteer community and member of ATRQ.',
    url: 'https://maryboroughwhistlestop.netlify.app/',
    image: '/portfolio/maryboroughwhistlestop.png',
    color: '#ec4899', // pink
    position: [-3, 1.5, 2],
    orbitRadius: 13,
    orbitSpeed: 0.0015,
    planetSize: 0.65,
    startAngle: Math.PI * 0.4, // 72 degrees
    planetType: 'gas',
  },
  {
    id: 6,
    title: 'Table to Text',
    category: 'React/SaaS',
    tech: ['React', 'Next.js', 'Client-side Processing', 'Privacy-First'],
    description: 'A privacy-focused web utility that converts spreadsheet data to clean, readable text format instantly. All processing happens in the browser, ensuring complete data privacy and security. Perfect for reports, documentation, and data analysis.',
    results: 'Free productivity tool serving the community with privacy-first architecture. No data collection, instant results, and universal compatibility with Excel, Google Sheets, and other spreadsheet applications.',
    url: 'https://tabletotext.com/',
    image: '/portfolio/tabletotext.png',
    color: '#f59e0b', // amber
    position: [-2, 1, -3],
    orbitRadius: 15,
    orbitSpeed: 0.0012,
    planetSize: 0.5,
    startAngle: Math.PI * 1.2, // 216 degrees
    planetType: 'lava',
  },
];
